export default "/assets/images/cc-balloon-md.3898bdfc03360380.png";